export default __webpack_public_path__ + "static/media/dti-logo.de6abed9.png";